import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/finance/invoices/$invoiceId',
}).lazy(() => import('./$invoiceId.index.lazy').then((d) => d.Route))
